export interface AttomOwnerResponseV1 {
  status: {
    version: string;
    code: number;
    msg: string;
    total: number;
    page: number;
    pagesize: number;
    transactionID: string;
  };
  property: [
    {
      identifier: {
        Id: number;
        fips: string;
        apn: string;
        attomId: number;
      };
      lot: {
        lotnum: string;
        lotsize1: number;
        lotsize2: number;
        pooltype: string;
      };
      area: {
        blockNum: string;
        loctype: string;
        countrysecsubd: string;
        countyuse1: string;
        muncode: string;
        munname: string;
        srvyRange: string;
        srvySection: string;
        srvyTownship: string;
        subdname: string;
      };
      address: {
        country: string;
        countrySubd: string;
        line1: string;
        line2: string;
        locality: string;
        matchCode: string;
        oneLine: string;
        postal1: string;
        postal2: string;
        postal3: string;
      };
      location: {
        accuracy: string;
        latitude: string;
        longitude: string;
        distance: number;
        geoid: string;
        geoIdV4: {
          CS: string;
          N1: string;
          PL: string;
          ZI: string;
          N2: string;
        };
      };
      summary: {
        absenteeInd: string;
        propclass: string;
        propsubtype: string;
        proptype: string;
        yearbuilt: number;
        propLandUse: string;
        propIndicator: string;
        legal1: string;
      };
      utilities: {
        heatingfuel: string;
        heatingtype: string;
      };
      building: {
        size: {
          bldgsize: number;
          grosssize: number;
          grosssizeadjusted: number;
          groundfloorsize: number;
          livingsize: number;
          sizeInd: string;
          universalsize: number;
        };
        rooms: {
          bathfixtures: number;
          bathsfull: number;
          bathstotal: number;
          beds: number;
          roomsTotal: number;
        };
        interior: {
          bsmtsize: number;
          bsmttype: string;
          fplccount: number;
          fplcind: string;
          fplctype: string;
        };
        construction: {
          condition: string;
          wallType: string;
        };
        parking: {
          prkgSize: number;
          prkgSpaces: string;
        };
        summary: {
          archStyle: string;
          levels: number;
          quality: string;
          unitsCount: string;
          view: string;
          yearbuilteffective: number;
        };
      };
      owner: {
        corporateindicator: string;
        owner1: {
          firstnameandmi: string;
          lastname: string;
        };
        owner2: {
          firstname: string;
          lastname: string;
        };
        owner3: {
          firstname: string;
          lastname: string;
        };
        owner4: {};
        ownerrelationshiprightscode: string;
        ownerrelationshiptype: string;
        absenteeownerstatus: string;
        mailingaddressoneline: string;
      };
      vintage: {
        lastModified: string;
        pubDate: string;
      };
    }
  ];
}
